module.exports = __webpack_public_path__ + "static/llama-desktop-936234f76efef6d71d214f8acee93b78.png";